import { CurrencyPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { DividerModule } from 'primeng/divider';

export interface Statistics {
  numberPropertiesPurchased: number;
  averagePurchasePrice: number;
  numberPropsBidOn: number;
  percentOfValue: number;
}

/**
 * Dumb component with the only responsibility to render input data within styled template
 */
@Component({
  selector: 'app-program-badge',
  templateUrl: './program-badge.component.html',
  styleUrls: ['./program-badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,

  imports: [FontAwesomeModule, DividerModule, CurrencyPipe],
})
export class ProgramBadgeComponent {
  @Input() mainColor: string = '';
  @Input() vipStateBackgroundColor = '';
  @Input() currentBadgePath: string = '';
  @Input() altImageText: string = '';
  @Input() headerText: string = '';
  @Input() vipStateText: string = '';
  @Input() vipLevelsStatistics: Statistics | null = null;

  public currentYear: string = new Date().getFullYear().toString();
}
